define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseModel = require("models/BaseModel");
    var ApiResources = require("assets/data/apiResources.json");
    var LEResourceResolver = require("leResourceResolver");

    var ContentCannedExportModel = {};
    LE.module("LEContent", function (LEContent, LE, Backbone, Marionette, $, _) {

        ContentCannedExportModel = BaseModel.extend({
            resourceApi: ApiResources.AccountConfigExport.ContentExport,
            name: "ContentCannedExportModel",
            resource: function() {
                var params = {
                    legacy: this.legacy,
                    include_skills: true,
                    include_lobs: LE.sessionManager.hasEntitiesTaggingByLobFeature()
                };
                return LEResourceResolver.extendResourceWithOptions.call(this, this.resourceApi, params);
            },

            initialize: function (options) {
                options = options || {};
                this.legacy = options.legacy || false;
            }
        });
    });

    return ContentCannedExportModel;
});
